import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  Router,
} from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FrontGuard implements CanActivate {
  isLoggedIn: any = false;
  constructor(
    public authService: AuthServiceService,
    public router: Router,
    private toastr: ToastrService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isLoggedIn = !!localStorage.getItem('access_token');
    const subscriptionStatus = localStorage.getItem('subscription_status');
    const role = this.authService._isRoleName;

    if (subscriptionStatus === 'expired') {
      return true;
    }
    else if (isLoggedIn && role != 0) {
      const dashboardUrl = '/' + role + '/dashboard';
      if (this.router.url !== dashboardUrl) {
        this.router.navigate([dashboardUrl]);
      }
      return false;
    }
    return true;
  }
}
